import logger from 'src/utils/logger/logger';
export default function detection(agent) {
  let comp_agent = false;
  if (agent.indexOf('netrange') === -1 || agent.indexOf('netrangemmh') === -1) {
    comp_agent = agent.indexOf('opera') != -1;
    if (comp_agent) {
      logger.info('[opera detection] detected');
    }
  }
  return comp_agent;
}



// WEBPACK FOOTER //
// ./src/devices/opera/detection.js